
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import FilePathService from '@/apps/shared/services/filePath-service';
    export default Vue.extend({
        components: {
        },
        name: 'UrbanMobilityPayment',
        data() {
            return {
                description: true,
                localItems: [{ text: 'Inicio', path: '/movilidad' }],
            }
        },
        methods: {
            changeTitleAndIcon() {
                // Lógica para determinar el nuevo título
                const newTitle = 'Movilidad urbana';

                // Emite eventos para actualizar el título
                this.$emit('updateTitle', newTitle);
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultUrbanMobilityGTMInfo';
                this.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        window.location.href = response + "movilidad";
                    });
            },
            getCUPE: function () {
                var email = "";
                var productId = 936;
                NF.UI.Page.blockCustom({ message: "Redirigiendo al pago" });
                var timeStart = new Date().getTime();
                CUPEService.GetCUPEUrl(productId, email).then(response => {
                    document.getElementById("pagoIframe").setAttribute('src', response.preferenceMessage);
                    document.getElementById('pagoIframe').addEventListener('load', () => {
                        this.loadingIframe = false;
                        var endTime = new Date().getTime();
                        var secondCharge = Math.round((endTime - timeStart) / 1000);
                        window.globalThis.dataLayer.push({ 'product': 'movilidad', 'event': 'cotizador-movilidad-checkout', 'carga': secondCharge });
                        NF.UI.Page.unblock();
                    });
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },
        },
        mounted() {
            this.changeTitleAndIcon();
            this.updateByProductGoogleAnalytics();
            this.getCUPE();
            var planDataSelected = sessionStorage.getItem("PlanSelected")
            if (planDataSelected != null) {
                this.DataPlan = JSON.parse(planDataSelected!);
                this.planDescription = this.DataPlan.planDescription;
                this.primerCuota = this.DataPlan.premioMensual
                this.coberturasAmparo = this.DataPlan.groupOfAmparoTheftOptions
            }
            sessionStorage.setItem("ExitOrContinueModal", "true")
        },
    });
